import { rootApi } from "@/services/api/api";
import type {
  AllPaymentPlansResponse,
  AllTariffResponse,
  CalculatePricePayload,
  CalculatePriceResponse,
  PaymentUrlPayload,
  PaymentUrlResponse,
  SubscriptionDTO,
  Tariff,
} from "@/services/api/entities/payment/types";

export const paymentApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllPlans: builder.query<AllPaymentPlansResponse, { externalId?: string }>({
      query: (params) => ({
        url: "/payment/plan/all",
        method: "GET",
        params,
      }),
    }),
    getAllTariffs: builder.query<AllTariffResponse, { externalId?: string }>({
      query: (params) => ({
        url: "/payment/tariff/all",
        method: "GET",
        params,
      }),
    }),
    getTariffById: builder.query<Tariff, { tariffId: string }>({
      query: (params) => ({
        url: "/payment/tariff",
        method: "GET",
        params,
      }),
    }),
    getPaymentUrl: builder.mutation<PaymentUrlResponse, PaymentUrlPayload>({
      query: (body) => ({
        url: "/payment/operation",
        method: "POST",
        body,
      }),
    }),
    getPaymentStatus: builder.query<PaymentUrlResponse, { paymentOperationId: string }>({
      query: (params) => ({
        url: "/payment/operation",
        method: "GET",
        params,
      }),
    }),
    getPriceCalculation: builder.query<CalculatePriceResponse, CalculatePricePayload>({
      query: (body) => ({
        url: "/payment/calculate",
        method: "POST",
        body,
      }),
    }),
    getCurrentSubscription: builder.query<SubscriptionDTO, void>({
      query: () => ({
        url: "/payment/subscription/current",
        method: "GET",
      }),
      providesTags: ["subscription"],
    }),
    getAllSubscriptions: builder.query<SubscriptionDTO[], void>({
      query: () => ({
        url: "/payment/subscription/all",
        method: "GET",
      }),
    }),
    cancelSubscription: builder.mutation<void, void>({
      query: () => ({
        url: "/payment/subscription/cancel",
        method: "POST",
      }),
      invalidatesTags: ["subscription"],
    }),
  }),
});

export const {
  useLazyGetAllPlansQuery,
  useGetPaymentUrlMutation,
  useGetPaymentStatusQuery,
  useGetAllTariffsQuery,
  useGetPriceCalculationQuery,
  useGetTariffByIdQuery,
  useGetCurrentSubscriptionQuery,
  useCancelSubscriptionMutation,
  useGetAllSubscriptionsQuery,
} = paymentApi;
